import { Button, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PieChart } from "@mui/x-charts";
import { GlobalState } from "context/GlobalContext";
import { brandList } from "data/businessPlanningData";
import { arrType, datatypes, inputTypes, objType } from "data/globalData";
import moment from "moment";
import { useEffect, useState } from "react";
import { allOption, replenishmentSelectedJobPath, selectOptKeyName } from "../../data";
import { DataGrid } from "@mui/x-data-grid";
import { DownloadRounded, RefreshRounded } from "@mui/icons-material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchBarWithDebounce from "./SearchBarWithDebounce/SearchBarWithDebounce";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import ResultTable from "./ResultTable/ResultTable";
import ReplJobs from "../ReplJobs/ReplJobs";
import axios from "axios";
import { AuthState } from "context/AuthContext";

const approachesValues = [
	{ name: "Any Size Over (Last 7-15 days)" },
	{ name: "Prime Size over M & L" },
	{ name: "Higher Multiple (Category Wise)" },
	{ name: "Store Category Wise" },
	{ name: "Non Prime Size" },
	{ name: "5/2 - Nearby map SUBCAT-COLOR-OLD SEASON" },
	{ name: "Suggest Which Store needs to exit what qty" },
	{ name: "Proof of the Pudding -Replenish ST Report" },
];

const filterColumns = {
	// start_date: {
	// 	name: "Start Date",
	// 	key: "start_date",
	// 	input_type: inputTypes.ENTER.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.DATE.key,
	// 	sort_no: 1,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// },
	// end_date: {
	// 	name: "End Date",
	// 	key: "end_date",
	// 	input_type: inputTypes.ENTER.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.DATE.key,
	// 	sort_no: 1,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// },
	brand: {
		name: "Brand",
		key: "brand",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				{ name: allOption, key: allOption },
				{ name: "RARE RABBIT", key: "RARE RABBIT" },
				{ name: "RAREISM", key: "RAREISM" },
			],
		},
	},
	division: {
		name: "Division",
		key: "division",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				{ name: allOption, key: allOption },
				{ name: "Apparels", key: "APPARELS" },
				{ name: "Addons", key: "ADDONS" },
				{ name: "Footwear", key: "FOOT WEAR" },
			],
		},
	},
};
const RenderBox = ({ row, field }) => {
	return (
		<Box
			width={"100%"}
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: row?.STORE === "Total" ? grey[200] : "inherit" }}>
			<Typography noWrap variant={row?.STORE === "Total" ? "h6" : "body2"}>
				{row[field]}
			</Typography>
		</Box>
	);
};

const ExecuteLogics = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();
	const navigate = useNavigate();

	const [selectedProfile, setSelectedProfile] = useState();
	const [jobs, setJobs] = useState();

	const onRunClick = async () => {
		if (!selectedProfile?.id) {
			setSnackBar({ ...snackBar, message: "Please select a profile", severity: "error" });
			setSnackBarOpen(true);
			return;
		}
		setLoadingOpen(true);
		try {
			const {
				data: { result },
			} = await pythonVmInstance.get(`/replenishment-v2/${selectedProfile?.id}?user_id=${user?.id}&user_email=${user.email}`);

			if (result.job_id) {
				navigate(`/${replenishmentSelectedJobPath}?id=${result.job_id}`);
			} else setLoadingOpen(false);
		} catch (error) {
			setSnackBar({ ...snackBar, message: parseErrMsgFromError(error), severity: "error" });
			setSnackBarOpen(true);
			setLoadingOpen(false);
		}
	};

	async function fetchReplJobs(offset, recordsLimit) {
		try {
			const res = await axios.get(`/api/replenishment/get_repl_jobs_list?limit=${recordsLimit}&offset=${offset}`);

			if (res?.data?.result) {
				return res?.data?.result?.jobs;
			} else return [];
		} catch (err) {
			console.log(err);
			setSnackBar({ ...snackBar, message: parseErrMsgFromError(err), severity: "error" });
			setSnackBarOpen(true);
			setLoadingOpen(false);

			return [];
		}
	}
	const handleRefreshClick = () => {
		setLoadingOpen(true);
		const fetch = async () => {
			let arr = await fetchReplJobs(0, 10);
			if (arr) {
				setJobs(arr);
				setLoadingOpen(false);
			}
		};
		fetch();
	};

	return (
		<Stack maxWidth="100%" spacing={2} margin="auto">
			<Box display="flex" alignItems="center" justifyContent="space-between">
				{/* <Typography variant="h4">Replenishment Summary</Typography> */}
			</Box>
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} alignItems="end">
				<Box width="40%">
					<SearchBarWithDebounce selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile} />
				</Box>

				<Box>
					<Button variant="contained" onClick={onRunClick} endIcon={<KeyboardArrowRightRoundedIcon />}>
						Run
					</Button>
				</Box>
			</Box>
			<Box>
				<Box display="flex" justifyContent="space-between" pb={1}>
					<Typography variant="h6">Logs</Typography>
					<Button
						variant="contained"
						size="small"
						startIcon={<RefreshRounded />}
						onClick={handleRefreshClick}
						sx={{ textTransform: "capitalize" }}>
						Refresh
					</Button>
				</Box>
				<ReplJobs jobs={jobs} setJobs={setJobs} fetchReplJobs={fetchReplJobs} />
			</Box>
		</Stack>
	);
};

export default ExecuteLogics;
